import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import SidebarLayout from './components/SidebarLayout';
import VisaoGeralPage from './pages/VisaoGeralPage';
import ProjecaoPage from './pages/ProjecaoPage';
import AssistentePage from './pages/AssistentePage';
import CaixaPage from './pages/CaixaPage';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#fff',
            color: '#1f2937',
            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
            borderRadius: '8px',
            fontSize: '14px',
          },
          success: {
            iconTheme: { primary: '#10b981', secondary: '#fff' },
          },
          error: {
            iconTheme: { primary: '#ef4444', secondary: '#fff' },
          },
        }}
      />
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Rotas protegidas dentro do SidebarLayout */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <SidebarLayout>
                <VisaoGeralPage />
              </SidebarLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/projecao"
          element={
            <ProtectedRoute>
              <SidebarLayout>
                <ProjecaoPage />
              </SidebarLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/assistente"
          element={
            <ProtectedRoute>
              <SidebarLayout>
                <AssistentePage />
              </SidebarLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/caixa"
          element={
            <ProtectedRoute>
              <SidebarLayout>
                <CaixaPage />
              </SidebarLayout>
            </ProtectedRoute>
          }
        />

        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;